import { collection, DocumentData, getDocs, query, where } from 'firebase/firestore';

import { INotification } from '@customTypes/notification';
import { formatErrorMessage } from 'external/firebase/controllers/utils';
import { db } from 'external/firebase/index';

export const getNotifications = async (email: string, groups: string[], role: string) => {
    try {
        const notificationsCollection = collection(db, 'notifications');

        // Query for notifications matching email
        const emailQuery = query(notificationsCollection, where('to.emails', 'array-contains', email));

        // Fetch email-based notifications
        const emailSnapshot = await getDocs(emailQuery);
        const emailNotifications: DocumentData[] = [];
        emailSnapshot.forEach(doc => {
            emailNotifications.push({ id: doc.id, ...doc.data() });
        });

        // Fetch group and role-based notifications only if groups array is not empty
        const groupRoleNotifications: DocumentData[] = [];

        if (groups.length > 0) {
            // eslint-disable-next-line no-restricted-syntax
            for (const group of groups) {
                const groupRoleQuery = query(
                    notificationsCollection,
                    where('to.groups', 'array-contains', group),
                    where('to.role', '==', role),
                );

                // eslint-disable-next-line no-await-in-loop
                const groupRoleSnapshot = await getDocs(groupRoleQuery);
                groupRoleSnapshot.forEach(doc => {
                    groupRoleNotifications.push({ id: doc.id, ...doc.data() });
                });
            }
        }

        // Combine the notifications
        const allNotifications = [...emailNotifications, ...groupRoleNotifications];

        // Filter the notifications by date range
        const currentDate = new Date();

        const filteredNotifications = allNotifications.filter(
            notification =>
                // @ts-ignore
                notification.startDate.toDate() <= currentDate && notification.endDate.toDate() >= currentDate,
        );

        return filteredNotifications as INotification[];
    } catch (error) {
        return formatErrorMessage(error);
    }
};
